import colors from "../../config/colors";
import { colorPalette } from "../../config/colorPalette";

const { brand, mercury, mercuryAlpha, red, salem } = colorPalette;

// Figma body3: Lexend 14 / 1.45
export const textSx = {
  fontFamily: '"Lexend", sans-serif',
  fontSize: 14,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: 1.45,
  letterSpacing: "0.1px",
};

export const labelSx = (disabled) => ({
  fontFamily: '"Lexend", sans-serif',
  fontSize: 12,
  fontWeight: 500,
  lineHeight: "18px",
  letterSpacing: "0.2px",
  color: disabled ? mercuryAlpha[28] : mercury[950],
});

export const messageSx = {
  fontFamily: '"Lexend", sans-serif',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: 1.35,
  letterSpacing: "0.15px",
  color: red[1000],
};

const STATUS_STYLES = {
  default: { bg: colors.white, border: mercuryAlpha[8] },
  error: { bg: red[100], border: red[300] },
  success: { bg: salem[100], border: salem[300] },
  disabled: { bg: mercury[100], border: mercury[300] },
};

export const getStatus = ({ error, success, disabled }) => {
  if (disabled) return "disabled";
  if (error) return "error";
  if (success) return "success";
  return "default";
};

// The bordered 44px box. The border is 1px inside Figma's box, so horizontal padding is
// 1px less than Figma's. Focus (orange border) only applies to the default status.
export const controlSx = (
  status,
  { padding = 11, focusWithin = true } = {},
) => ({
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  height: 44,
  padding: `0 ${padding}px`,
  borderRadius: "8px",
  backgroundColor: STATUS_STYLES[status].bg,
  border: `1px solid ${STATUS_STYLES[status].border}`,
  ...(status === "default" && focusWithin
    ? { "&:focus-within": { borderColor: brand[700] } }
    : {}),
});

export const inputSx = (disabled) => ({
  ...textSx,
  flex: 1,
  minWidth: 0,
  padding: 0,
  border: "none",
  outline: "none",
  background: "transparent",
  color: disabled ? mercuryAlpha[28] : mercury[950],
  "&::placeholder": {
    color: disabled ? mercuryAlpha[28] : mercuryAlpha[65],
    opacity: 1,
  },
});
